<img [src]="creditCardToImage[type]" alt="..." [ngStyle]="{ 'width.px': width, 'height.px': height }">
